import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

function getAccessToken () {
  return Vue.prototype.$cookie.get('accessToken')
}

function load (component) {
  return () => import(`@/${component}.vue`)
}

function hideModals () {
  store.dispatch('modal/hideAllModals', {}, { root: true })
}

function isMicrosoft () {
  /* Maybe someday
  ** One Browser to rule them all, One Browser to browse web,
  ** One Browser to bring them all and in the darkness bind them
  */
  const ua = navigator.userAgent
  const match = /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(ua)
  if (match) return parseInt(match[2])
  return false
}

const router = new Router({
  root: '/',
  mode: 'history',
  routes: [
    {
      path: '/unsupported',
      name: 'unsupported',
      meta: {
        title: 'Unsupported Browser'
      },
      component: load('components/browser/BrowserNotSupported')
    },
    {
      path: '/',
      component: load('views/Authenticated'),
      beforeEnter (to, from, next) {
        if (isMicrosoft()) {
          router.push('/unsupported')
          next()
        } else if (getAccessToken()) {
          next()
        } else {
          store.dispatch('user/logout', true)
        }
      },
      children: [
        {
          name: 'home',
          path: '',
          redirect: '/files'
        },
        {
          path: '/files',
          name: 'files',
          meta: {
            title: 'KingsCloud'
          },
          component: load('views/files-view/FilesView'),
          children: [
            {
              path: '/files/:folderId',
              name: 'folder',
              meta: {
                title: 'Folder'
              }
            }
          ]
        },
        {
          path: '/media',
          name: 'media',
          meta: {
            title: 'Media'
          },
          component: load('views/media-view/MediaView')
        },
        {
          path: '/settings',
          name: 'settings',
          meta: {
            title: 'Settings'
          },
          component: load('views/settings-view/SettingsView')
        },
        {
          path: '/search/:searchString',
          name: 'search',
          meta: {
            title: 'Search'
          },
          component: load('views/search-view/SearchView')
        },
        {
          path: '*',
          name: 'notFound',
          meta: {
            title: '404'
          },
          component: load('views/not-found-view/NotFoundView')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  Vue.prototype.$Progress.finish()
  Vue.prototype.$Progress.start()
  next()
})

router.afterEach((to, from) => {
  hideModals()
  Vue.prototype.$Progress.finish()
  document.title = to.meta.title ? `KingsCloud | ${to.meta.title}` : 'KingsCloud'
})

export default router
